var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 369,
    viewBox: "0 0 369 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_340_254)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.948,
    y: 47.7012,
    width: 183.093,
    height: 142.68,
    rx: 16,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.412,
    y: 133.474,
    width: 43.7113,
    height: 36.2887,
    rx: 8,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.165,
    y: 74.9175,
    width: 50.3093,
    height: 50.3093,
    rx: 25.1546,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.0718,
    y: 83.9897,
    width: 67.6289,
    height: 67.6289,
    rx: 33.8144,
    fill: "url(#paint0_linear_340_254)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5879 160.69C87.4514 160.691 105.175 178.415 105.175 200.278V226.67H188.475C197.584 226.67 204.969 234.055 204.969 243.165C204.969 252.275 197.584 259.66 188.475 259.66H42.4951C42.4714 259.66 42.4475 259.659 42.4238 259.659H28.1309C26.9543 259.659 26.0001 258.706 26 257.529V200.278C26 178.415 43.7242 160.69 65.5879 160.69Z",
    fill: "url(#paint1_linear_340_254)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67.6289,
    height: 67.6289,
    rx: 33.8144,
    transform: "matrix(-1 0 0 1 337.752 149.144)",
    fill: "url(#paint2_linear_340_254)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.412 223.371C284.549 223.371 266.825 241.095 266.825 262.959V289.351H183.525C174.416 289.351 167.031 296.736 167.031 305.846C167.031 314.955 174.416 322.34 183.525 322.34H343.869C345.046 322.34 346 321.386 346 320.21V262.959C346 241.095 328.276 223.371 306.412 223.371Z",
    fill: "url(#paint3_linear_340_254)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.969,
    y: 74.9175,
    width: 65.1546,
    height: 12.3711,
    rx: 6.18557,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.969,
    y: 100.484,
    width: 45.3608,
    height: 11.5464,
    rx: 5.7732,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.041,
    y: 149.144,
    width: 65.9794,
    height: 8.24742,
    rx: 4.12371,
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_340_254",
    x: 26,
    y: 47.7012,
    width: 320,
    height: 274.639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_340_254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_254",
    x1: 77.7683,
    y1: 103.516,
    x2: 28.4195,
    y2: 151.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_340_254",
    x1: 138.989,
    y1: 189.266,
    x2: 76.6688,
    y2: 298.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_340_254",
    x1: 37.3985,
    y1: 13.3648,
    x2: -2.96857,
    y2: 69.2842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_340_254",
    x1: 247.031,
    y1: 242.929,
    x2: 289.892,
    y2: 350.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.c7c48d46687eaccffb8721838db61b2f.svg";
export { ForwardRef as ReactComponent };